import React from 'react';

import Icon from '../../../components/AppIcon';

const FeaturesShowcase = () => {
  const features = [
    {
      id: 1,
      icon: 'CheckCircle2',
      iconColor: 'text-green-400',
      title: 'Spot-On Shakespeare',
      description: 'Word-for-word script precision with synchronized audio and glossary tooltips that make understanding every line effortless.'
    },
    {
      id: 2,
      icon: 'Zap',
      iconColor: 'text-yellow-400',
      title: '3x Faster Learning',
      description: 'Our smart algorithms adapt to your pace, helping you grasp complex concepts three times faster than traditional methods.'
    },
    {
      id: 3,
      icon: 'TrendingUp',
      iconColor: 'text-blue-400',
      title: 'Improve Test Scores',
      description: 'Proven quiz systems with instant feedback help you ace assessments and raise your grades with confidence.'
    },
    {
      id: 4,
      icon: 'Award',
      iconColor: 'text-purple-400',
      title: 'Trending Education App',
      description: 'Join thousands of students worldwide who\'ve made Shakespeare fun, social, and genuinely exciting to learn.'
    }
  ];


  return (
    <section className="py-24 lg:py-32 relative bg-gray-900/95">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6">
            Powerful <span className="gradient-text">Features</span>
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Everything you need to master Shakespeare's works
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features?.map((feature) => (
            <div
              key={feature?.id}
              className="modern-card group hover:scale-105 transition-all duration-300"
            >
              <div className="flex items-start space-x-5">
                <div className="flex-shrink-0 pt-1">
                  <Icon name={feature?.icon} size={28} className={feature?.iconColor} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-2">
                    {feature?.title}
                  </h3>
                  <p className="text-white/70 leading-relaxed">
                    {feature?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesShowcase;